var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[(_vm.isLoading)?_c('div',{staticClass:"overlay-loader"},[_c('div',{staticClass:"spinner"})]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }